import { computed, type Ref } from 'vue'

export function useProductGridStyling(fetching: Readonly<Ref<boolean>>) {
    const classGrid = computed(() => ({
        'fetching': fetching.value,
    }))

    return {
        classGrid,
    }
}
